import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import Form from './form';
import { Holders } from 'civil-status/view-models/step-form';

interface HolderAccordionProps {
  holder: Holders;
}

const HolderAccordionComponent = ({ holder }: HolderAccordionProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="accordion-head-act-content"
          id="accordion-head-act-header"
          expandIcon={<ExpandMore />}
        >
          <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {holder.title || ''}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Form values={holder} />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

HolderAccordionComponent.displayName = 'Holder Accordion Component';

const HolderAccordion = memo(HolderAccordionComponent);

export default HolderAccordion;
